<template>
  <router-view />
</template>

<script setup>
import {
} from 'vue';

</script>

<style lang="scss" scoped>

</style>
